import axios from "@/request";
import qs from "qs";

export default {
  async getBills(params: any) {
    return axios.get("bill/list", { params });
  },
  async detail(params: any) {
    return axios.get("bill/detail", { params });
  },
  async cancelBill(params: any) {
    return axios.post("bill/cancel", qs.stringify(params));
  },
  async getSettlementBills(params: any) {
    return axios.get("settlement-record/orders", { params });
  },
  async getSettlementHuman(params: any) {
    return axios.get("settlement-record/human", { params });
  },
  async getSettlementSms(params: any) {
    return axios.get("settlement-record/sms", { params });
  },
  async getSettlementRecharge(params: any) {
    return axios.get("settlement-record/recharge", { params });
  },
  async getPayChannels(params: any) {
    return axios.get("bill/paymentchannel", { params });
  },
  async exportBills(params: any) {
    return axios.get("bill/export", {
      params,
      responseType: "blob"
    });
  },
  async exportBills1(params: any) {
    return axios.get("bill/export", { params });
  },
  async exportCheck(params: any) {
    return axios.get("bill/check-export",{params});
  },
  async compareSettlement(params: any) {
    return axios.post("settlement-record/compare", params, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  async compareWithDatabase(params: any) {
    return axios.get("settlement-record/compare-with-database", { params });
  },
  async phone(params: any) {
    return axios.get("bill/phone", { params });
  },
  async card(params: any) {
    return axios.get("bill/card", { params });
  },
  async exportcard(params: any) {
    return axios.get("bill/exportcard", {
      params,
      responseType: "blob"
    });
  },
  async history(params: any) {
    return axios.get("bill/history", { params });
  },
  async overview(params: any) {
    return axios.get("bill/overview", { params });
  },
  async share(params: any) {
    return axios.get("bill/share", { params });
  },
  async discounts(params: any) {
    return axios.get("bill/discounts", { params });
  },
  async product(params: any) {
    return axios.get("bill/product", { params });
  },
  async reductions(params: any) {
    return axios.get("bill/reductions", { params });
  },
  async confirmWechatBill(params: any) {
    return axios.post("bill/confirm-wechat-bill", qs.stringify(params));
  },
  async denyWechatBill(params: any) {
    return axios.post("bill/deny-wechat-bill", qs.stringify(params));
  },
  async noticeWechatBill(params: any) {
    return axios.post("bill/notice-wechat-bill", qs.stringify(params));
  },
  async multiWechatBill(params: any) {
    return axios.post("bill/multi-wechat-bill", qs.stringify(params));
  },
  async services(params: any) {
    return axios.get("bill/services", { params });
  },
  async serviceCancel(params: any) {
    return axios.post("bill/service-cancel", qs.stringify(params));
  },
  async serviceRefund(params: any) {
    return axios.post("bill/service-refund", qs.stringify(params));
  },
  async taisamHistory(params: any) {
    return axios.get("bill/taisam-history", { params });
  },
  async deposit(params: any) {
    return axios.get("stadium-manage-record/list-deposit", { params });
  },
  async reject(params: any) {
    return axios.get("stadium-manage-record/cancel", { params });
  },
  async devops(params: any) {
    return axios.get("stadium-manage-record/list-devops", { params });
  },
  async bindstadium(params: any) {
    return axios.post("stadium-manage-record/bind-stadium", qs.stringify(params));
  }
};
